import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        font-family: ${props => props.theme.typography.fontFamily};
        background-color: ${props => props.theme.colors.background.main};
        color: ${props => props.theme.colors.text.primary};
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    /* Target root containers if needed */
    #root, .mobile-wrapper {
        min-height: 100vh;
        background-color: ${props => props.theme.colors.background.main};
    }
`;
